import { useState } from "react";
import styles from "./CookieBanner.module.css";

const storageKey = "visible-online-cookie-consent";

export default function CookieBanner() {
  const [visible, setVisible] = useState(() => !localStorage.getItem(storageKey));

  const choose = (value) => {
    localStorage.setItem(storageKey, value);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside className={styles.banner} aria-label="Cookie consent">
      <div>
        <strong>We respect your privacy</strong>
        <p>We use essential cookies to keep the site working. Optional cookies help us improve your experience. <a href="/privacy-policy">Learn more</a></p>
      </div>
      <div className={styles.actions}>
        <button className={styles.secondary} onClick={() => choose("essential")}>Essential only</button>
        <button className={styles.primary} onClick={() => choose("accepted")}>Accept all</button>
      </div>
    </aside>
  );
}
